import { RG_TYPE } from "@project-rouge/rg-core";
import { getActiveZones } from "./index186.js";
import { getRgObjectsOfType } from "@project-rouge/rg-three";
const getActiveBuildings = (parent, aggProps) => {
  return getActiveZones(parent, aggProps).flatMap((zone) => getRgObjectsOfType(zone, RG_TYPE.Building));
};
export {
  getActiveBuildings
};
//# sourceMappingURL=index183.js.map
